import gql from 'graphql-tag';

export default gql`
    fragment MortuaryLocation on Funeral {
        MortuaryLocation {
            ID
            Name
        }
    }
`;
